import { world } from '../../languages';
import fetchAllEntities from '../../utils/fetch-all-entities';

type WishlistItem = { id: number; _total: number };

export type GetWishlistSummaryResponse = { list: WishlistItem[]; total: number };

const getWishlistSummary = async (url: string): Promise<GetWishlistSummaryResponse> => {
    const schema = `{
            wishlist (
                filter: { and: [
                    { world: "${world}" }
                    { isActive: true }
                    { deletedAt: null }
                ] },
                pagination: { limit: 200 },
                order_by: { sort: id, order: ASC }
            ) {
                    id
                    _total
                }
        }`;

    const response = await fetchAllEntities(url, schema, 'wishlist');
    const { wishlist } = response.data;

    let total = 0;

    if (wishlist[0] && wishlist[0].id) {
        total = wishlist[0]._total;
    }

    return { list: wishlist, total };
};

export default getWishlistSummary;
